import {Modal, Button} from 'components/ui';
import LetrusLoader from 'components/LetrusLoader';
import styles from './FocusModeExpireModal.module.scss';

interface FocusModeExpireModalProps {
  phase: 'idle' | 'waiting' | 'submitting' | 'done';
  onGoToDashboard: () => void;
  submittingMessage?: string;
  doneMessage?: string;
}

/**
 * FocusModeExpireModal
 *
 * Shown when the Focus Mode timer expires.
 * - 'waiting': timer expired while offline — shows spinner until reconnect
 * - 'submitting': shows a spinner while registered expire callbacks run (e.g. composition upload)
 * - 'done': shows a confirmation message and a button to go back to the dashboard
 */
function FocusModeExpireModal({
  phase,
  onGoToDashboard,
  submittingMessage = 'Enviando...',
  doneMessage = 'Seu tempo de atividade foi encerrado.',
}: FocusModeExpireModalProps): JSX.Element | null {
  if (phase === 'idle') return null;

  const isDone = phase === 'done';

  return (
    <Modal
      isOpen
      onClose={isDone ? onGoToDashboard : () => {}}
      clickOutsideToClose={false}
      buttonClose={false}
      minWidth={500}
      maxWidth={500}
      vw={90}
    >
      <div className={styles.container}>
        {phase === 'done' ? (
          <>
            <p className={styles.title}>Tempo esgotado</p>
            <p className={styles.message}>{doneMessage}</p>
            <Button
              text="Concluir"
              variant="primary"
              onClick={onGoToDashboard}
            />
          </>
        ) : (
          <>
            <LetrusLoader />
            <p className={styles.message}>
              {phase === 'waiting'
                ? 'Aguardando reconexão para enviar suas respostas...'
                : submittingMessage}
            </p>
          </>
        )}
      </div>
    </Modal>
  );
}

export default FocusModeExpireModal;
